var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.GENRE.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-30"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("프라이빗 세일(Private Sales) 장르")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h3', {
    staticClass: "tit tit--sm line-height-14"
  }, [_vm._v("프라이빗 세일의 장르(카테고리)는 7개 부문입니다. "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("주로 현대미술 및 고미술 등 미술품 중심으로 구성되었습니다.")])])], 1)], 1), _c('private-genre-banner')], 1), _c('section', {
    staticClass: "page-section"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("출품 조건")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "pb-16 pb-md-24"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("작가 기준")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("프라이빗 세일에는 1국내외 근현대 대표작가 및 2Emerging Artist를중심으로 출품 됩니다.")])])]), _c('v-divider', {
    staticClass: "grey-cb"
  }), _c('div', {
    staticClass: "py-16 py-md-24"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("작품 기준")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("프라이빗 세일에는 <상태등급> 및 <가치 등급>이 B등급 이상인 작품을 출품합니다.")])])]), _c('v-divider', {
    staticClass: "grey-cb"
  }), _c('div', {
    staticClass: "pt-16 pt-md-24"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("진품 보증")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("프라이빗 세일에는 <진품이 보증>된 작품만 출품됩니다.")])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mt-10 mt-lg-20"
  }, [_c('v-simple-table', {
    staticClass: "v-simple-table v-data-table--none-active-bg v-data-table--default text-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("작가 기준")]), _c('th', [_vm._v("작품 기준")]), _c('th', [_vm._v("제공 서류")])])]), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page-text primary--text"
  }, [_c('p', [_vm._v("- 근대 대표작가")]), _c('p', [_vm._v("- 현대 대표작가")]), _c('p', [_vm._v("- Emerging Artist")])])]), _c('td', [_c('div', {
    staticClass: "page-text primary--text"
  }, [_c('p', [_vm._v("- 작품 상태등급 : B급 이상")]), _c('p', [_vm._v("- 작품 가치등급 : B급 이상")])])]), _c('td', [_c('div', {
    staticClass: "page-text primary--text"
  }, [_c('p', [_vm._v("- 상태검사서")]), _c('p', [_vm._v("- 작품이력서")]), _c('p', [_vm._v("- 작품설명서")]), _c('p', [_vm._v("- 출품확인서")]), _c('p', [_vm._v("- 진품보증서(감정기관, 작가)")])])])])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticStyle: {
      "letter-spacing": "-.04em!important"
    }
  }, [_vm._v("※ 제공 서류 : 프라이빗 세일에 출품된 작품의 구매자에게는 다음의 5가지 서류가 제공됩니다.")]), _c('p', [_vm._v("※ 작품 가치등급은 캐터옥션 <가치등급 기준표>를 적용하여 부여합니다.")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "mt-n16 mt-md-n20 mt-lg-0"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("※ 작품 판매시, 대금지불 및 운송 등의 내용은, 경매작품과 동일하게 적용되며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("자세한 사항은 다음을 참조하시기 바랍니다.")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "pa-0 v-btn--none-active-bg",
    attrs: {
      "small": "",
      "text": "",
      "height": "auto",
      "color": "grey-68",
      "to": "/"
    }
  }, [_c('strong', [_vm._v("자세히보기")]), _c('v-icon', [_vm._v("mdi-menu-right")])], 1)], 1)])])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }